module.exports = __webpack_public_path__ + "static/img/social4-1x.0701242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social4-1x.jpg
// module id = A/oN
// module chunks = 0